import { createSlice } from '@reduxjs/toolkit';

export const initialState = {};

const mappingSlice = createSlice({
	name: 'mapping',
	initialState,
	reducers: {
		setMapping(state, action) {
			return action.payload;
		}
	}
});

export const { setMapping } = mappingSlice.actions;

export default mappingSlice.reducer;
